package com.elan.edubridge.data.firebase

import com.elan.edubridge.data.firebase.externals.Firestore
import com.elan.edubridge.data.firebase.externals.doc
import com.elan.edubridge.data.firebase.externals.getDoc
import com.elan.edubridge.shared.data.firebase.FirebaseNaming
import kotlinx.coroutines.await

/** 웹 스태프 셸이 학원 루트 문서에서 구독 배너에 필요한 두 필드만 꺼내 쓰는 읽기 모델. */
internal data class AcademySubscriptionSnapshot(
    val state: String?,
    val expiryTimeMillis: Double?,
)

internal object AcademySubscriptionReader {
    private lateinit var firestore: Firestore

    /** [installWebGraph]의 named Firestore 인스턴스를 그대로 사용한다. */
    fun configure(firestore: Firestore) {
        this.firestore = firestore
    }

    suspend fun read(academyId: String): AcademySubscriptionSnapshot? {
        val snapshot = getDoc(doc(firestore, FirebaseNaming.ACADEMIES, academyId)).await()
        if (!snapshot.exists()) return null
        val subscription = snapshot.data()["subscription"]
        if (subscription == null || jsTypeOf(subscription) != "object") return null
        val expiryTimeMillis = subscription["expiryTimeMillis"]
        return AcademySubscriptionSnapshot(
            state = stringOrNull(subscription, "state"),
            expiryTimeMillis = if (jsTypeOf(expiryTimeMillis) == "number") {
                expiryTimeMillis as Double
            } else {
                null
            },
        )
    }
}
